import React, { useEffect, useRef, useState } from "react";

const VERSION_URL = "/version.json";
const POLL_INTERVAL = 5 * 60 * 1000;

const VersionChecker: React.FC = () => {
  const currentVersionRef = useRef<string | null>(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);

  const fetchVersion = async () => {
    try {
      const response = await fetch(VERSION_URL, { cache: "no-store" });
      if (!response.ok) return;

      const data = await response.json();

      if (
        currentVersionRef.current &&
        data.version !== currentVersionRef.current
      ) {
        setUpdateAvailable(true);
      }

      if (!currentVersionRef.current) {
        currentVersionRef.current = data.version;
      }
    } catch (error) {
      console.error("Error fetching version.json:", error);
    }
  };

  useEffect(() => {
    fetchVersion();
    const interval = setInterval(fetchVersion, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, []); // <-- empty dependency array

  if (!updateAvailable) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        backgroundColor: "#323232",
        color: "white",
        padding: "10px 20px",
        borderRadius: 5,
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
        zIndex: 1000,
        cursor: "pointer",
      }}
      onClick={() => window.location.reload()}
      role="button"
    >
      A new version is available. Click here to update.
    </div>
  );
};

export default VersionChecker;
